
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
          hid: 'description',
          name: 'description',
          content: 'Experience the best dinner cruises in Goa with breathtaking views, live music, and exquisite cuisine on board luxury yachts and boats.',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: 'Discover the top dinner cruises in Goa, featuring unforgettable sunsets, scenic river views, and world-class dining. Perfect for romantic evenings or group outings.',
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: 'Enjoy a magical evening with Goa’s best dinner cruises, offering fine dining, music, and scenic views. Perfect for special occasions.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'best dinner cruise in goa, best dinner cruise in goa for family, best dinner cruise in goa for couples, romantic dinner cruise in goa, luxury dinner cruise in goa',
        },
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],

      title: 'Best Dinner Cruise in Goa - Best Dinner Cruise in Goa for Family and Couples',
    };
  },


 jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/best-dinner-cruise-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/best-dinner-cruise-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/best-dinner-cruise-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Best Dinner Cruise in Goa - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Dinner Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/best-dinner-cruise-goa",
        "url": "https://www.goa.app/best-dinner-cruise-goa",
        "name": "Best Dinner Cruise in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-38c9a.appspot.com/2022-10-19T07%3A42%3A02.041Z2-%282%29.webp?GoogleAccessId=firebase-adminsdk-h8jpw%40goa-app-38c9a.iam.gserviceaccount.com&Expires=16446997800&Signature=F2MqEsr4ERNckxPpV%2B8KUWBbZvT%2BOeFCVYGBQDZ9H6t5aduwQtXdAprvv%2BAWvEsgUGUYcMvOnbSjx3cIbfHKdqyGV%2F2tflAqpTs5J7ctpJMJ44DzjTGcICH9vOJx9n3Yx56p4uhHrjEbjith6%2BntP3GUAGWqO4AcNXSlYarv4FzUw4Kv0CmO8DpCWtyTuZ6eVWeB6KGiC%2FyFDqGGi5coxSAhRtglg5JdArLsUpEtbUhzmQ4oTUC5%2FjELKu3v1GKJaoVsPqcM83NVhUALvFaGwcQzyv%2FaCRs0VpuDLubC2EUC2MvAw3tkwyGdczTHaJPuatLY8BEVyruP5xXpNehUzQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Best Dinner Cruises in Goa offer a memorable experience with scenic views, delicious meals, and entertainment. Ideal for relaxation or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while sailing along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/best-dinner-cruise-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/best-dinner-cruise-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How do I book a Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book a Best Dinner Cruise in Goa through various online platforms or by contacting local operators. Booking in advance, especially during peak season, is recommended to secure your spot."
      }
    },
    {
      "@type": "Question",
      "name": "What is included in a Best Dinner Cruise in Goa package?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Best Dinner Cruise in Goa packages typically include the cruise, crew, and basic amenities. Some packages offer extras like meals, beverages, and entertainment on board."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for a Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It’s recommended to wear comfortable, smart casual attire. Dress for the weather and don't forget your swimwear if you plan to take a dip or engage in water activities."
      }
    },
    {
      "@type": "Question",
      "name": "How long can I enjoy the Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Best Dinner Cruises in Goa can last anywhere from a couple of hours to a full night, depending on the package. Longer cruises for special occasions can often be arranged."
      }
    },
    {
      "@type": "Question",
      "name": "Can I customize the experience on a Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many operators allow customization for special occasions such as birthdays or anniversaries. You can add elements like decorations, meals, and entertainment."
      }
    },
    {
      "@type": "Question",
      "name": "Are meals and drinks included in the Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some Best Dinner Cruises in Goa include meals and drinks, while others may offer them as an optional add-on. It's best to confirm with the cruise provider when booking."
      }
    },
    {
      "@type": "Question",
      "name": "What is the price range for Best Dinner Cruises in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prices for Best Dinner Cruises in Goa typically start from ₹500 and can go up depending on the duration, inclusions, and amenities offered."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book a Best Dinner Cruise in Goa for a special occasion?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Best Dinner Cruises in Goa are perfect for special occasions like anniversaries or celebrations. Many operators offer tailor-made packages for such events."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time to book a Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time to book a Best Dinner Cruise in Goa is between November and February when the weather is pleasant. However, cruises are available year-round for a memorable experience."
      }
    },
    {
      "@type": "Question",
      "name": "Can I bring my own food and drinks on a Best Dinner Cruise in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some Best Dinner Cruise operators allow you to bring your own food and beverages, while others provide catering services. It's advisable to check with the provider in advance."
      }
    },
    {
      "@type": "Question",
      "name": "Are Best Dinner Cruises in Goa suitable for water sports?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many Best Dinner Cruises in Goa offer additional water sports activities such as jet skiing and fishing. You can inquire about these options when booking your cruise."
      }
          }

        ]
      }
    ]
  };
},


};


  